import BookmarkButton from '@/components/BookmarkButton'
import IcoMoon from '@/components/IcoMoon'
import { getConfig } from '@/lib/config'
import { formatDuration } from '@/lib/datetime'
import { AIElementNames, eventsTracker } from '@/lib/eventsTracker'
import { ItemType } from '@/shared/api-generated-types'

interface Props {
  id: string
  title: string
  slug: string
  image?: string
  guideName?: string
  guideAvatarUrl?: string
  durationSeconds?: number
  bookmarked?: boolean
}

const GenericCard = (props: Props): JSX.Element => {
  const config = getConfig()
  const detailsPageLink = `${config.publicRuntimeConfig.website.url}/helen-recommendations/watch/${props.id}`

  return (
    <a
      href={detailsPageLink}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => eventsTracker.handleOnClickAndTrackEvent(AIElementNames.BUTTON_CLASS_CARD)}
      className="flex flex-row items-center w-full gap-2 bg-white hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 border-b border-[#eaeaef] py-3"
    >
      <div className="h-16 w-16 sm:h-[72px] sm:w-32 xxl:h-24 xxl:w-[171px] flex cursor-pointer rounded-md relative bg-[50%_50%] overflow-hidden">
        <span
          className="absolute top-0 bottom-0 left-0 right-0 w-full bg-no-repeat bg-cover"
          style={{
            backgroundImage: props.image ? `url(${props.image})` : `url('/images/image-placeholder-large.png')`,
          }}
        ></span>
        <BookmarkButton
          bookmarked={props.bookmarked}
          size="sm"
          itemId={props.id}
          itemType={ItemType.Class}
          className="absolute right-[8px] top-[8px] rounded"
        />
      </div>
      <div className="flex flex-col self-stretch flex-1 gap-1 pr-2 break-all whitespace-pre-wrap lg:py-3">
        <h3 className="font-bold text-sm sm:text-base text-[#2D2D32]">{props.title}</h3>
        {props.guideName ? (
          <div className="flex items-center text-xs xxl:text-sm basis-1 text-[#757582]">
            {props.guideAvatarUrl ? (
              <div className="relative w-4 h-4 sm:w-5 sm:h-5 xxl:w-6 xxl:h-6 overflow-hidden bg-[#ccc] ml-0 mr-2 my-0 rounded-[50%]">
                <img src={props.guideAvatarUrl} alt={props.guideName ?? ''} sizes="40px" />
              </div>
            ) : null}
            By {props.guideName}
          </div>
        ) : (
          <div>&nbsp;</div>
        )}
        {props.durationSeconds && (
          <div className="flex gap-1 basis-1 text-[#2d2d32] items-end">
            <span className="font-bold w-[14px] sm:w-4 xxl:w-5">
              <IcoMoon icon="youtube" className="h-full w-full" />
            </span>
            <span className="text-xs xxl:text-sm">{formatDuration(props.durationSeconds)}</span>
          </div>
        )}
      </div>
    </a>
  )
}
export default GenericCard
